import React from 'react';
import DiscoveryTool from './DiscoveryTool';

const App: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4" style={{ backgroundColor: '#FDCB58' }}>
      <DiscoveryTool />
    </div>
  );
};

export default App;
